'use client';

import Image from '@/components/media/SiteImage';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';

export default function HeroBackground({
  alt = 'Cosy cabin in Finnish Lapland',
  scrollLabel = 'Scroll',
}: {
  alt?: string;
  scrollLabel?: string;
}) {
  return (
    <>
      {/* Background image */}
      <div className="absolute inset-0">
        <Image
          src="/images/hero/hero-winter.jpg"
          alt={alt}
          fill
          className="object-cover"
          priority
          sizes="100vw"
        />
      </div>

      {/* Dark overlay */}
      <div
        className="absolute inset-0"
        style={{
          background:
            'linear-gradient(to bottom, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0.35) 50%, rgba(0,0,0,0.55) 100%)',
        }}
      />

      {/* Scroll indicator */}
      <motion.div
        className="hidden lg:flex absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex-col items-center gap-1"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.2, duration: 0.8 }}
      >
        <span className="text-[10px] uppercase tracking-[0.2em] font-sans text-white/50">
          {scrollLabel}
        </span>
        <motion.div
          animate={{ y: [0, 6, 0] }}
          transition={{ repeat: Infinity, duration: 1.8, ease: 'easeInOut' }}
        >
          <ChevronDown size={20} className="text-white/50" />
        </motion.div>
      </motion.div>
    </>
  );
}
